import { DollarSign, FileText, AlertTriangle, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CompanyBillingList } from "@/components/admin/CompanyBillingList";
import { useInvoiceStats } from "@/hooks/useInvoices";

export function BillingAdminPage() {
  const { data: invoiceStats, isLoading: invoiceStatsLoading } = useInvoiceStats();

  const formatCurrency = (cents: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(cents / 100);
  };

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Faturamento</h1>
        <p className="text-muted-foreground">Gerencie cobranças e faturas por empresa</p>
      </div>

      {/* KPIs Unificados */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Receita Total</CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {invoiceStatsLoading ? '...' : formatCurrency(invoiceStats?.totalAmount || 0)}
            </div>
            <p className="text-xs text-muted-foreground">
              {invoiceStats?.total || 0} faturas emitidas
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Pendente</CardTitle>
            <FileText className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-yellow-600">
              {invoiceStatsLoading ? '...' : (invoiceStats?.byStatus?.pending || 0)}
            </div>
            <p className="text-xs text-muted-foreground">
              aguardando pagamento
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Em Atraso</CardTitle>
            <AlertTriangle className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-red-600">
              {invoiceStatsLoading ? '...' : (invoiceStats?.overdue || 0)}
            </div>
            <p className="text-xs text-muted-foreground">
              faturas vencidas
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Este Mês</CardTitle>
            <TrendingUp className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">
              {invoiceStatsLoading ? '...' : (invoiceStats?.thisMonth || 0)}
            </div>
            <p className="text-xs text-muted-foreground">
              faturas emitidas
            </p>
          </CardContent>
        </Card>
      </div>

      {/* Lista de Empresas Agrupada */}
      <CompanyBillingList />
    </div>
  );
}

export default BillingAdminPage;